function formatComment(text) {
    return text
        .replace(/\\/g, '\\\\')   // екрануємо зворотні слеші
        .replace(/"/g, '\\"')     // екрануємо подвійні лапки
        .replace(/\n/g, '\\n')    // замінюємо новий рядок на \n
        .replace(/\t/g, '\\t');   // замінюємо табуляцію на \t
}

function formatColumnName(colName) {
    // Основні зарезервовані слова SQLite (з офіційної документації)
    const reserved = new Set([
        'abort', 'action', 'add', 'after', 'all', 'alter', 'analyze', 'and', 'as', 'asc',
        'attach', 'autoincrement', 'before', 'begin', 'between', 'by', 'cascade', 'case',
        'cast', 'check', 'collate', 'column', 'commit', 'conflict', 'constraint', 'create',
        'cross', 'current_date', 'current_time', 'current_timestamp', 'database', 'default',
        'deferrable', 'deferred', 'delete', 'desc', 'detach', 'distinct', 'drop', 'each',
        'else', 'end', 'escape', 'except', 'exclusive', 'exists', 'explain', 'fail', 'for',
        'foreign', 'from', 'full', 'glob', 'group', 'having', 'if', 'ignore', 'immediate',
        'in', 'index', 'indexed', 'initially', 'inner', 'insert', 'instead', 'intersect',
        'into', 'is', 'isnull', 'join', 'key', 'left', 'like', 'limit', 'match', 'natural',
        'no', 'not', 'nothing', 'notnull', 'null', 'of', 'offset', 'on', 'or', 'order',
        'outer', 'plan', 'pragma', 'primary', 'query', 'raise', 'recursive', 'references',
        'regexp', 'reindex', 'release', 'rename', 'replace', 'restrict', 'right', 'rollback',
        'row', 'savepoint', 'select', 'set', 'table', 'temp', 'temporary', 'then', 'to',
        'transaction', 'trigger', 'union', 'unique', 'update', 'using', 'vacuum', 'values',
        'view', 'virtual', 'when', 'where', 'with', 'without'
    ]);

    // Перевірки
    const hasSpecialChars = /[^a-zA-Z0-9_]/.test(colName);  // пробіли або спецсимволи
    const startsWithNumber = /^[0-9]/.test(colName);        // починається з цифри
    const isReserved = reserved.has(colName.toLowerCase()); // зарезервоване слово

    // Якщо потрібно — беремо в подвійні лапки (SQL-стандарт)
    if (hasSpecialChars || startsWithNumber || isReserved) {
        return `"${colName}"`;
    }

    return colName;
}

function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    // const seconds = String(date.getSeconds()).padStart(2, '0');

    // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}

/**
 * Генерує SQL код для створення таблиць MySQL на основі заданого об'єкта.
 * @param {Object} tables - Об'єкт, що описує таблиці та колонки.
 * Структура об'єкту:
 * {
 *      "table_id": {
 *          "id": "table_id",
 *          "value": {
 *              "header": {
 *                  "name": "table_name",
 *              },
*               "columns": {
*                   "column_id": {
*                       "id": "column_id",
*                       "name": "column_name",
*                       "type": "VARCHAR(255)",
*                       "isPK": false,
*                       "isFK": false,
*                       "isAutoIncrement": false,
*                       "isNN": false,
*                       "enumValues": null,
*                       "defaultValue": null,
*                       "checkValue": null,
*                       "generatedValue": null,
*
*                       "isGeneratedValueVirtual": false,
*                       "isGeneratedValueStored": false,
*                       "onUpdate": null,
*
*                       "fkRefTable": null,
*                       "fkRefColumn": null,
*                       "index": {
*                         "compositeColumns": null,
*                         "isRegular": false,
*                         "isUnique": false,
*                         "isComposite": false,
*                         "isFullText": false,
*                         "indexName": null
*                       }
*                   }
*               }
*           }
*       }
*  }
* @param {string} projectName - Ім'я проєкту (для преамбули).
* @param {string} projectVersion - Версія проєкту (для преамбули).
* @param {string} mysqlVersion - Цільова версія MySQL
* @returns {string} SQL код для створення всіх таблиць.
*/
export default function generateCode(
    tables,
    projectName = 'Core Service',
    // projectDescription = 'Current service is Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
    // projectVersion = '1.4.43',
    mysqlVersion = '8.0' // '8.0', '5.7'
) {
    const exportDate = formatDate(new Date());
    const serviceName = 'dbdesign.io';

    const statements = [];

    const commentsDefinitionsByTables = {};
    const indexesDefinitionsByTables = {};
    const foreignKeysDefinitionsByTables = {};

    // -- ----------------------------------------------
    // -- Project Name: --------- Core Service ---------
    // -- Database: ------------- MySQL ----------------
    // -- Export Date: ---------- 2024-12-21 22:10:15 --
    // -- Created By: ----------- dbdesign.io ----------
    // -- ----------------------------------------------


    // -- Project Version: ------ 1.4.43 ---------------
    // -- Description:
    // -- (max 120 symbols)
    // -- (max 120 symbols)
    // -- (max 120 symbols)
    // -- ==============================================

    const preambulaName = `Project Name: --------- ${projectName}`;
    // const preambulaVersion = `Project Version: ------ ${projectVersion}`;
    const preambulaDB = `Database: ------------- MySQL`; // ${mysqlVersion}`;
    const preambulaDate = `Export Date: ---------- ${exportDate}`;
    const preambulaCreatedBy = `Created By: ----------- ${serviceName}`;
    // const preambulaDescription = `Description:`;

    const preambulaLength = Math.max(
        preambulaName.length,
        // preambulaVersion.length,
        preambulaDB.length,
        preambulaDate.length,
        preambulaCreatedBy.length,
    ) + 3;

    let preambulaStatement = '';
    preambulaStatement += `-- ${'-'.repeat(preambulaLength)}`;

    preambulaStatement += `\n-- ${preambulaName} ${'-'.repeat(preambulaLength - preambulaName.length - 1)}`;
    // preambulaStatement += `\n-- ${preambulaVersion} ${'-'.repeat(preambulaLength - preambulaVersion.length - 1)}`;
    preambulaStatement += `\n-- ${preambulaDB} ${'-'.repeat(preambulaLength - preambulaDB.length - 1)}`;

    // preambulaStatement += `\n-- ${'-'.repeat(preambulaLength)}`;

    preambulaStatement += `\n-- ${preambulaDate} ${'-'.repeat(preambulaLength - preambulaDate.length - 1)}`;
    preambulaStatement += `\n-- ${preambulaCreatedBy} ${'-'.repeat(preambulaLength - preambulaCreatedBy.length - 1)}`;

    preambulaStatement += `\n-- ${'-'.repeat(preambulaLength)}`;

    // preambulaStatement += `\n-- ${preambulaDescription}`;
    // preambulaStatement += `\n-- ${projectDescription}`;

    // preambulaStatement += `\n-- ${'='.repeat(preambulaLength)}`;

    statements.push(preambulaStatement);

    // ============ TRANSACTION: START ============
    const transactionStartStatement = 'START TRANSACTION;';
    statements.push(transactionStartStatement);

    // ============ TABLES ===================
    for (const tableKey in tables) {
        const table = tables[tableKey];
        const { value: { header: { name: tableName }, columns, description: tableDescription } } = table;

        // inside 'create table' statement

        const columnsDefinitions = [];

        const primaryKeys = [];
        const primaryKeysDefinitions = [];

        const uniqueIndexes = [];
        const uniqueDefinitions = [];

        const checks = [];
        const checksDefinitions = [];

        // after of 'create table' statement

        const indexes = [];
        const indexesDefinitions = [];

        const foreignKeys = [];
        const foreignKeysDefinitions = [];

        // const comments = [];
        const commentsDefinitions = [];

        // ============ COLUMNS START ============
        for (const columnKey in columns) {
            const col = columns[columnKey];

            // ====== COLUMN NAME ======
            // ====== FORMAT: "`column_name`"
            let colDef = `\`${col.name}\``;

            // ====== COLUMN TYPE ======
            // ====== FORMAT: " column_type"
            if (col.type !== 'enum' && !col.generatedValue) {
                colDef += ` ${col.type}`;
            }

            // ====== ENUM ======
            // ====== FORMAT: " ENUM(column1, column2)"
            if (col.enumValues && Array.isArray(col.enumValues) && col.enumValues.length > 0) {
                const enumList = col.enumValues.map(v => `'${v}'`).join(', ');
                colDef += ` ENUM(${enumList})`;
            }

            // ====== GENERATED VALUE ======
            // ====== FORMAT: " GENERATED ALWAYS AS (generated_expression)"
            // ====== FORMAT: " GENERATED ALWAYS AS (generated_expression) VIRTUAL"
            // ====== FORMAT: " GENERATED ALWAYS AS (generated_expression) STORED"
            if (col.generatedValue) {
                colDef += ` GENERATED ALWAYS AS (${col.generatedValue})`;

                // ====== VIRTUAL ======
                if (col.isGeneratedValueVirtual) {
                    colDef += ` VIRTUAL`;

                    // ====== STORED ======
                } else if (col.isGeneratedValueStored) {
                    colDef += ` STORED`;
                }
            } else {

                // ====== NOT NULL ======
                // ====== FORMAT: " NOT NULL"
                if (col.isNN) {
                    colDef += ` NOT NULL`;
                }

                // ====== DEFAULT VALUE ======
                // ====== FORMAT: " DEFAULT 'default_string'"
                // ====== FORMAT: " DEFAULT default_number"
                if (col.defaultValue !== null && col.defaultValue !== undefined) {

                    // ====== STRING ======
                    if (typeof col.defaultValue === 'string') {
                        colDef += ` DEFAULT '${col.defaultValue}'`;
                    } else {
                        // ====== NUMBER / CURRENT_TIMESTAMP ======
                        colDef += ` DEFAULT ${col.defaultValue}`;
                    }
                }

                // ====== AUTO_INCREMENT ======
                // ====== FORMAT: " AUTO_INCREMENT"
                if (col.isAutoIncrement) {
                    colDef += ` AUTO_INCREMENT`;
                }

                // ====== ON_UPDATE ======
                // ====== FORMAT: " ON UPDATE on_update_action"
                if (col.onUpdate) {
                    colDef += ` ON UPDATE ${col.onUpdate}`;
                }

                // ====== ADD TO CHECKS (SINGLE COLUMN) ======
                // ====== MYSQL 8.0 ==========================
                if (mysqlVersion == '8.0' && col.checkValue) {
                    checks.push({
                        columnNames: [col.name],
                        checkName: col.checkName,
                        checkValue: col.checkValue,
                    });
                }
            }

            // ====== ADD TO PRIMARY KEYS ======
            if (col.isPK) {
                primaryKeys.push(col.name);
            }

            // ====== ADD TO FOREIGN KEYS ======
            if (col.isFK && col.fkRefTable && col.fkRefColumn) {
                foreignKeys.push({
                    tableName: tableName,
                    columnNames: [col.name],

                    refTableName: col.fkRefTable,
                    refColumnNames: [col.fkRefColumn],

                    onUpdateTrigger: col.onUpdateTrigger,
                    onDeleteTrigger: col.onDeleteTrigger,
                });
            }

            // ====== ADD TO INDEXES ======
            if (col.index) {
                const idx = col.index;
                // index = { isRegular, isUnique, isFullText, isComposite, indexName, compositeColumns }

                // ====== UNIQUE ======
                // if (idx.isUnique) {
                if (idx.type === 'unique') {
                    uniqueIndexes.push({
                        columnNames: [col.name],
                        type: 'unique',
                    });

                    // ====== FULLTEXT ======
                    // } else if (idx.isFullText) {
                } else if (idx.type === 'fullText') {
                    indexes.push({
                        tableName: tableName,
                        columnNames: [col.name],
                        type: 'fullText',
                    });

                    // ====== SPATIAL ======
                    // } else if (idx.isSpatial) {
                } else if (idx.type === 'spatial') {
                    indexes.push({
                        tableName: tableName,
                        columnNames: [col.name],
                        type: 'spatial',
                    });

                    // ====== REGULAR ======
                    // } else if (idx.isRegular) {
                } else {
                    indexes.push({
                        tableName: tableName,
                        columnNames: [col.name],
                        type: 'regular',
                    });
                }
            }

            // ====== COMMENTS ==========
            if (col.description) {
                colDef += ` COMMENT "${col.description}"`;
            }

            columnsDefinitions.push(colDef);
        }
        // ============ COLUMNS END ============

        // ============ PRIMARY KEY ============
        // ====== FORMAT: "CONSTRAINT key_name PRIMARY KEY (`column1`, `column2`)"
        if (primaryKeys.length > 0) {
            const pkName = `\`pk_${tableName}\``;
            const pkDefinition = `CONSTRAINT ${pkName} PRIMARY KEY (${primaryKeys.map(c => `\`${c}\``).join(', ')})`;

            primaryKeysDefinitions.push(pkDefinition);
        }

        // ====== UNIQUE INDEX =================
        // ====== FORMAT: "UNIQUE KEY `table1_col1_col2_uq_idx` (`column1`)"
        uniqueIndexes.forEach((idx, i) => {
            const columnNames = idx.columnNames || [];
            const columnNamesFormated = columnNames.map(column => `\`${column}\``).join(', ');

            const indexName = idx.indexName || `${tableName}_${columnNames.join('_')}_uq_idx`;
            let indexDefinition = `UNIQUE KEY \`${indexName}\` (${columnNamesFormated})`;

            uniqueDefinitions.push(indexDefinition);
        });

        // ====== CHECK ========================
        // ====== MYSQL 8.0 ====================
        // ====== FORMAT: "CHECK (check_expression)"
        // ====== FORMAT: "CONSTRAINT check_name CHECK (check_expression)"
        if (mysqlVersion == '8.0' && checks.length) {
            checks.forEach((chk, i) => {
                const checkName = chk.checkName || `chk_${chk.columnNames.join('_')}`;
                checksDefinitions.push(`CONSTRAINT \`${checkName}\` CHECK (${chk.value})`);
            });
        }

        // ============ FOREIGN KEYS ===========
        // ====== FORMAT: ALTER TABLE `table1` ADD CONSTRAINT `fk_name` FOREIGN KEY (`col1`, `col2`) REFERENCES `table2`(`col1`, `col2`) ON UPDATE CASCADE ON DELETE CASCADE;
        if (foreignKeys.length) {
            for (const fk of foreignKeys) {
                const tableName = fk.tableName;
                const columnNames = fk.columnNames || [];
                const columnNamesFormated = columnNames.map(column => `\`${column}\``).join(', ');

                const refTableName = fk.refTableName;
                const refColumnNames = fk.refColumnNames || [];
                const refColumnNamesFormated = refColumnNames.map(column => `\`${column}\``).join(', ');

                const onUpdateTrigger = fk.onUpdateTrigger;
                const onDeleteTrigger = fk.onDeleteTrigger;

                const fkName = fk.fkName || `fk_${tableName}_${columnNames.join('_')}`;

                let foreignKeyDef = '';
                foreignKeyDef += `ALTER TABLE \`${tableName}\` ADD CONSTRAINT \`${fkName}\` FOREIGN KEY (${columnNamesFormated}) REFERENCES \`${refTableName}\`(${refColumnNamesFormated})`;
                if (onUpdateTrigger) {
                    foreignKeyDef += ` ON UPDATE ${onUpdateTrigger}`;
                }
                if (onDeleteTrigger) {
                    foreignKeyDef += ` ON DELETE ${onDeleteTrigger}`;
                }

                foreignKeyDef += `;`;
                foreignKeysDefinitions.push(foreignKeyDef);
            }

            foreignKeysDefinitionsByTables[tableName] = foreignKeysDefinitions;
        }

        // ====== INDEX ================
        // ====== FORMAT: ALTER TABLE `table1` ADD [UNIQUE | FULLTEXT | SPATIAL] INDEX `table1_col1_col2_uq_idx` (`col1`, `сol2`) USING [BTREE | HASH];
        if (indexes.length) {
            indexes.forEach((idx, i) => {
                const tableName = idx.tableName;
                const columnNames = idx.columnNames || [];
                const columnNamesFormated = columnNames.map(column => `\`${column}\``).join(', ');

                let indexType = '';
                let indexTypeShort = '';

                if (idx.type === 'unique') {
                    indexType = 'UNIQUE';
                    indexTypeShort = 'uq';
                } else if (idx.type === 'fullText') {
                    indexType = 'FULLTEXT';
                    indexTypeShort = 'txt';
                } else if (idx.type === 'spatial') {
                    indexType = 'SPATIAL';
                    indexTypeShort = 'sptl';
                } else if (idx.type === 'regular') {
                    // REGULAR
                    // nothing.
                } else {
                    // REGULAR
                    // nothing.
                }

                const indexName = idx.indexName || `${tableName}_${columnNames.join('_')}_${indexTypeShort ? indexTypeShort + '_' : ''}idx`;
                let indexDefinition = `ALTER TABLE \`${tableName}\` ADD ${indexType ? indexType + ' ' : ''}INDEX \`${indexName}\` (${columnNamesFormated});`;

                indexesDefinitions.push(indexDefinition);
            });

            indexesDefinitionsByTables[tableName] = indexesDefinitions;
        }

        // ====== COMMENTS ==============
        // ====== FORMAT: ALTER TABLE `table1` COMMENT = 'new table comment';
        if (tableDescription) {
            let commentDefinition = `ALTER TABLE \`${tableName}\` COMMENT "${tableDescription}";`;
            commentsDefinitions.push(commentDefinition);

            commentsDefinitionsByTables[tableName] = commentsDefinitions;
        }

        // ============ RESULT =================================================================================================
        // ============ CREATE TABLE ============
        const isColumns = columnsDefinitions.length;
        const isPrimary = primaryKeysDefinitions.length;
        const isUnique = uniqueDefinitions.length;
        const isCheck = checksDefinitions.length;

        let createStatement = '';
        createStatement += `CREATE TABLE IF NOT EXISTS \`${tableName}\` (`;

        if (isColumns) {
            createStatement += `\n  ${columnsDefinitions.join(',\n  ')}${isPrimary || isUnique || isCheck ? ',\n  ' : ''}`;
        }

        if (isPrimary && isUnique) {
            createStatement += '  -- PRIMARY / UNIQUE';
            createStatement += `\n  ${[...primaryKeysDefinitions, ...uniqueDefinitions].join(',\n  ')}${isCheck ? ',\n  ' : ''}`;
        } else if (isPrimary) {
            createStatement += '  -- PRIMARY';
            createStatement += `\n  ${primaryKeysDefinitions.join(',\n  ')}${isCheck ? ',\n  ' : ''}`;
        } else if (isUnique) {
            createStatement += '  -- UNIQUE';
            createStatement += `\n  ${uniqueDefinitions.join(',\n  ')}${isCheck ? ',\n  ' : ''}`;
        }

        if (isCheck) {
            createStatement += '  -- CHECK';
            createStatement += `\n  ${checksDefinitions.join(',\n  ')}`;
        }
        // createStatement += `\n) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4;`;
        createStatement += `\n);`;

        statements.push(createStatement);
    }

    // ============ COMMENTS: FINAL ===========
    const commentsKeys = Object.keys(commentsDefinitionsByTables);
    if (commentsKeys.length) {
        let commentStatements = [];
        const commentsHeaderStatement = "-- ---------- COMMENTS ---------------";
        commentStatements.push(commentsHeaderStatement);

        commentsKeys.forEach(commentKey => {
            const commentsDefs = commentsDefinitionsByTables[commentKey];
            commentStatements.push(commentsDefs.join('\n'));
        });
        statements.push(commentStatements.join('\n'));
    }

    // ============ INDEXES: FINAL ===========
    const indexesKeys = Object.keys(indexesDefinitionsByTables);
    if (indexesKeys.length) {
        let indexStatements = [];
        const indexesHeaderStatement = "-- ---------- INDEXES ----------------";
        indexStatements.push(indexesHeaderStatement);

        indexesKeys.forEach(indexKey => {
            const indexesDefs = indexesDefinitionsByTables[indexKey];
            indexStatements.push(indexesDefs.join('\n'));
        })
        statements.push(indexStatements.join('\n'));
    }

    // ============ FOREIGN KEYS: FINAL ===========
    const fkKeys = Object.keys(foreignKeysDefinitionsByTables);
    if (fkKeys.length) {
        let fkStatements = [];
        const fkHeaderStatement = "-- ---------- FOREIGN KEYS -----------";
        fkStatements.push(fkHeaderStatement);

        fkKeys.forEach(fkKey => {
            const fkDefs = foreignKeysDefinitionsByTables[fkKey];
            fkStatements.push(fkDefs.join('\n'));
        })
        statements.push(fkStatements.join('\n'));
    }

    // ============ TRANSACTION: END ============
    const transactionEndStatement = 'COMMIT;';
    statements.push(transactionEndStatement);

    return statements.join('\n\n') + '\n\n';
}
